import { __assign, __read, __rest, __spread } from "tslib";
import { DEFAULT_SOURCE, } from '@atlaskit/analytics-gas-types';
import { ELEMENTS_CONTEXT, EDITOR_CONTEXT, } from '@atlaskit/analytics-namespaced-context';
import merge from 'lodash.merge';
import { ELEMENTS_TAG } from './FabricElementsListener';
import { EDITOR_TAG } from './FabricEditorListener';
var extractFieldsFromContext = function (fieldsToPick) { return function (contexts) {
    return contexts
        .map(function (ctx) {
        return fieldsToPick.reduce(function (result, key) {
            var _a;
            return ctx[key] ? merge(result, (_a = {}, _a[key] = ctx[key], _a)) : result;
        }, {});
    })
        .reduce(function (result, item) { return merge(result, item); }, {});
}; };
var fieldExtractor = function (contextKey) {
    return extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey,
    ]);
};
var getContextKey = function (tag) {
    switch (tag) {
        case ELEMENTS_TAG:
            return ELEMENTS_CONTEXT;
        case EDITOR_TAG:
            return EDITOR_CONTEXT;
        default:
            return '';
    }
};
var updatePayloadWithContext = function (primaryTag, event) {
    if (event.context.length === 0) {
        return __assign({ source: DEFAULT_SOURCE }, event.payload);
    }
    var contextKey = getContextKey(primaryTag) || 'attributes';
    var _a = fieldExtractor(contextKey)(event.context), _b = contextKey, attributes = _a[_b], fields = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    if (attributes) {
        event.payload.attributes = merge(attributes, event.payload.attributes || {});
    }
    return __assign(__assign({ source: DEFAULT_SOURCE }, fields), event.payload);
};
var addTags = function (tags, originalTags) {
    if (originalTags === void 0) { originalTags = []; }
    var mergedTags = new Set(__spread(originalTags, tags));
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */
function getPrimaryTag(tags) {
    if (typeof tags === 'string') {
        return tags;
    }
    if (!tags.length) {
        throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    }
    return tags[0];
}
export var processEventPayload = function (event, tags) {
    var primaryTag = getPrimaryTag(tags);
    var tagsArray = typeof tags === 'string' ? [tags] : tags;
    return __assign(__assign({}, updatePayloadWithContext(primaryTag, event)), { tags: addTags(tagsArray, event.payload.tags) });
};
//# sourceMappingURL=process-event-payload.js.map